const testimonialData = [
    {
        "img": "https://picsum.photos/200",
        "name": "Joe Dow",
        "text": "Absolute perfection every visit. It's like they know exactly what I need!"
    },
    {
        "img": "https://picsum.photos/300",
        "name": "Jane Smith",
        "text": "Their service is outstanding and truly tailored to my family's needs."
    },
    {
        "img": "https://picsum.photos/400",
        "name": "Sam Lee",
        "text": "Reliable, efficient, and always a pleasure to have around."
    }
];
export default testimonialData;